<template>
  <FlexTableTitle
    :title="$t(`enums.engineering.chromatography.methods.${norm}.${method}`)"
    :hasAlarms="hasAlarms"
    :executed="executed"
  >
  </FlexTableTitle>
</template>

<script>
import FlexTableTitle from '../../../FlexTableTitle';

export default {
  name: 'ChromatographyFlexTableTitle',
  components: {
    FlexTableTitle,
  },
  props: {
    hasAlarms: {
      type: Boolean,
    },
    executed: {
      type: Boolean,
      default: true,
    },
    method: {
      type: String,
    },
    norm: {
      type: String,
    },
  },
};
</script>
